<template>
  <suspense>
    <template #default>
      <router-view></router-view>
    </template>

    <template #fallback>
      Chargement...
    </template>
  </suspense>
</template>
